"use client";

import React from "react";

export function EditorSkeleton() {
  return (
    <div className="overflow-hidden rounded-xl border border-indigo-300 bg-white">
      <div className="flex flex-wrap items-center gap-2 border-b border-indigo-200 bg-indigo-50 p-2">
        <div className="h-8 w-14 animate-pulse rounded-md bg-indigo-200/70" />
        <div className="h-8 w-14 animate-pulse rounded-md bg-indigo-200/70" />
        <div className="mx-1 h-6 w-px bg-indigo-200" />
        <div className="h-8 w-10 animate-pulse rounded-md bg-indigo-200/70" />
        <div className="h-8 w-10 animate-pulse rounded-md bg-indigo-200/70" />
        <div className="h-8 w-16 animate-pulse rounded-md bg-indigo-200/70" />
        <div className="h-8 w-16 animate-pulse rounded-md bg-indigo-200/70" />
      </div>
      <div className="min-h-[150px] animate-pulse bg-white px-4 py-4">
        <div className="h-4 w-3/4 rounded bg-slate-200" />
        <div className="mt-3 h-4 w-5/6 rounded bg-slate-200" />
        <div className="mt-3 h-4 w-2/3 rounded bg-slate-200" />
      </div>
    </div>
  );
}
